/**
 * Artikelfinder im Konto: Knopf einblenden, Dialog oeffnen und schliessen
 * (Aufgabe #58, 23.09.2026).
 *
 * ⚠️ Dieses Modul enthaelt KEINE Suchlogik. Die steht in artikelfinder.js und
 * verdrahtet sich selbst ueber die af-*-Ids — hier geht es nur um Sichtbarkeit
 * und um das Fenster drumherum. Wer hier Suchcode ergaenzt, hat ihn doppelt.
 *
 * Aufbau bewusst nach dem Vorbild von konto-pricelist.js: gleiche
 * Sitzungspruefung, gleiche Dialogsteuerung, gleiche Namen. Zwei Knoepfe
 * nebeneinander, die sich innen unterschiedlich verhalten, sind eine Falle fuer
 * den naechsten, der hier etwas aendert.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'b2b_session';

  var el = {};
  var lastFocus = null;

  function $(id) { return document.getElementById(id); }
  function show(n) { if (n) n.style.display = ''; }
  function hide(n) { if (n) n.style.display = 'none'; }

  /**
   * Die B2B-Sitzung aus dem localStorage, oder null.
   *
   * ⚠️ Abgelaufene Sitzungen gelten als nicht vorhanden. Identisch zu
   * konto-pricelist.js — laufen die beiden auseinander, zeigt das Konto zwei
   * Knoepfe mit unterschiedlicher Vorstellung davon, wer angemeldet ist.
   */
  function session() {
    try {
      var raw = localStorage.getItem(SESSION_KEY);
      if (!raw) { return null; }
      var s = JSON.parse(raw);
      if (s.expiresAt && new Date(s.expiresAt) < new Date()) { return null; }
      return s;
    } catch (e) { return null; }
  }

  /**
   * ⚠️⚠️ „Verifiziert" ist hier STRENGER als bei der Preisliste, die sich mit
   * einer Sitzung begnuegt.
   *
   * Der Artikelfinder zeigt Listenpreise und rechnet eine Ersparnis gegen die
   * Preise des bisherigen Lieferanten. Wer noch auf die Freischaltung wartet,
   * soll das gar nicht erst sehen — nicht weil es geheim waere, sondern weil
   * eine Ersparnisrechnung fuer ein Konto, das noch nicht bestellen kann, ein
   * Versprechen ist, das wir nicht halten.
   */
  function darfSehen(s) {
    return !!s && s.isB2B === true && s.isUnverified !== true && s.isDisabled !== true;
  }

  /**
   * Fragt den Server, ob dieses Konto den Finder sehen darf.
   *
   * ⚠️ Bei JEDEM Fehlschlag gilt „nein". Netzfehler, 401, kaputte Antwort — in der
   * Pilotphase ist ein unsichtbarer Knopf harmlos, ein sichtbarer bei der falschen
   * Firma nicht. Die sichere Richtung ist dieselbe wie beim leeren Default der
   * Allowlist auf dem Server.
   */
  function statusFragen(email, fertig) {
    var cfg = window.b2bConfig || {};
    var basis = cfg.apiBase || 'https://pim.schaltschrank24.ch';
    var key = cfg.apiKey || '';

    if (!key) {
      if (window.console) {
        console.error('[Artikelfinder] window.b2bConfig hat keinen apiKey — Knopf bleibt versteckt.');
      }
      fertig(false);
      return;
    }

    var koerper = new URLSearchParams();
    koerper.append('email', email || '');

    fetch(basis + '/api/b2b/finder/status', {
      method: 'POST',
      headers: { 'X-Api-Key': key, 'Content-Type': 'application/x-www-form-urlencoded' },
      body: koerper
    }).then(function (r) {
      if (!r.ok) { throw new Error('Antwort ' + r.status); }
      return r.json();
    }).then(function (d) {
      fertig(!!(d && d.enabled));
    }).catch(function (e) {
      if (window.console) { console.warn('[Artikelfinder] Status nicht abrufbar:', e); }
      fertig(false);
    });
  }

  function openDialog() {
    lastFocus = document.activeElement;
    el.overlay.style.display = 'flex';
    // ⚠️ Der Hintergrund darf nicht mitscrollen — sonst verliert man auf dem
    // Telefon den Dialog aus dem Blick und findet ihn nicht wieder.
    document.body.style.overflow = 'hidden';

    var feld = $('af-suche');
    if (feld && feld.focus) { feld.focus(); }
  }

  function closeDialog() {
    el.overlay.style.display = 'none';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function init() {
    el.trigger = $('konto-af-trigger');
    el.overlay = $('konto-af-overlay');
    el.dialog  = $('konto-af-dialog');
    el.close   = $('konto-af-close');

    // ⚠️ Fehlt eines der Teile, ist das Markup nicht da (anderes Theme, aeltere
    // Section). Dann still aussteigen statt beim ersten Klick zu scheitern.
    if (!el.trigger || !el.overlay || !el.dialog) { return; }

    var sess = session();
    if (!darfSehen(sess)) { return; }

    // ⚠️⚠️ Der Knopf bleibt versteckt, BIS der Server zustimmt. Andersherum — erst
    // zeigen, dann verstecken — blitzt er bei jedem Seitenaufruf kurz auf, und in
    // der Pilotphase saehen ihn genau die Leute, die ihn nicht sehen sollen.
    statusFragen(sess.email, function (erlaubt) {
        if (erlaubt) { show(el.trigger); }
    });

    el.trigger.addEventListener('click', openDialog);
    if (el.close) { el.close.addEventListener('click', closeDialog); }

    // Klick auf den abgedunkelten Rand schliesst — aber nur dort, nicht im
    // Dialog selbst.
    el.overlay.addEventListener('click', function (ev) {
      if (ev.target === el.overlay) { closeDialog(); }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && el.overlay.style.display !== 'none') { closeDialog(); }
    });
  }

  // ⚠️ Das Skript laeuft mit defer, das Dokument ist also geparst. Der
  // zusaetzliche Zweig fuer 'loading' kostet nichts und macht das Modul
  // unabhaengig davon, wie es eingebunden wird.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
